import { Sha256 as BrowserSha256 } from '@aws-crypto/sha256-browser';

import { signingEnhancerFactory } from './signing.js';

import type { SigningEnhancerOptions } from './signing.js';
import type { FetchEnhancer } from '../../main.js';

/**
 * Signing enhancer automatically signs (sigv4) requests using the provided credentials.
 */
export const signingEnhancer: FetchEnhancer<SigningEnhancerOptions> =
  signingEnhancerFactory(BrowserSha256);

export { SigningEnhancerOptions, CredentialsProvider } from './signing.js';
